export default {
  metaDescription: 'Ikuti berita terbaru, update proyek, dan wawasan industri dari PT Tokki Engineering and Fabrication (TEF).',
  pageTitle: 'Berita & Blog',
  readMore: 'BACA SELENGKAPNYA',
  byAdmin: 'Oleh Admin',
  empty: 'Belum ada berita atau artikel blog saat ini.',
};
